export default function Commitment() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">(Cam Kết Của Chúng Tôi)</h2>
        </div>

        {/* Rating Badge */}
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 bg-gray-900 px-5 py-2 rounded-full">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-star-fill text-amber-400 text-lg"></i>
            </div>
            <span className="text-white text-sm font-bold">5.0</span>
            <span className="text-gray-400 text-sm">Đánh giá từ khách hàng</span>
          </div>
        </div>

        {/* Quote Content */}
        <div className="relative">
          <div className="absolute -top-6 -left-2 text-8xl text-teal-200 font-serif">"</div>
          <div className="relative z-10 text-gray-700 text-lg leading-relaxed space-y-4 pl-8">
            <p>
              Chúng tôi cam kết <strong className="text-gray-900">không ép giá</strong>, <strong className="text-gray-900">không phát sinh chi phí ẩn</strong>, thu mua nhanh chóng trong ngày. Mọi giao dịch đều <strong className="text-gray-900">minh bạch, rõ ràng</strong>.
            </p>
            <p>
              Giá thu mua luôn <strong className="text-gray-900">cạnh tranh nhất thị trường</strong>. Đội ngũ chuyên nghiệp, phục vụ tận tâm 24/7. Nam Phát luôn đặt uy tín và sự hài lòng của khách hàng lên hàng đầu.
            </p>
            <p>
              Với hơn 15 năm kinh nghiệm, chúng tôi tự hào là đối tác tin cậy của hàng nghìn khách hàng trên toàn quốc. <strong className="text-gray-900">Một lần hợp tác - Trọn đời tin tưởng</strong>.
            </p>
          </div>
          <div className="absolute -bottom-6 right-0 text-8xl text-teal-200 font-serif">"</div>
        </div>

        {/* Author Info */}
        <div className="flex items-center gap-4 mt-12 pl-8">
          <img
            src="https://public.readdy.ai/ai/img_res/8eee93020fb3ceba97c016277d0b5b89.jpg"
            alt="Giám đốc"
            className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg"
          />
          <div>
            <div className="text-gray-900 font-bold text-base">Nguyễn Văn Nam</div>
            <div className="text-gray-600 text-sm">Giám Đốc - Công Ty TNHH Phế Liệu Nam Phát</div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex items-center justify-end gap-3 mt-12">
          <button className="w-12 h-12 bg-white border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
            </div>
          </button>
          <button className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}